package com.example.readingnotes.di

import com.example.readingnotes.data.remote.api.ApiClient
import com.example.readingnotes.data.repository.AuthRepositoryImpl
import com.example.readingnotes.data.repository.CommentRepositoryImpl
import com.example.readingnotes.data.repository.NotificationRepositoryImpl
import com.example.readingnotes.data.repository.PostRepositoryImpl
import com.example.readingnotes.data.repository.TagRepositoryImpl
import com.example.readingnotes.domain.repository.AuthRepository
import com.example.readingnotes.domain.repository.CommentRepository
import com.example.readingnotes.domain.repository.NotificationRepository
import com.example.readingnotes.domain.repository.PostRepository
import com.example.readingnotes.domain.repository.TagRepository
import com.example.readingnotes.domain.usecase.*

class AppModule(
    // Android emulator localhost
    baseUrl: String = "http://10.0.2.2:3001",
) {
    private val apiClient = ApiClient(baseUrl)

    // Repositories
    val postRepository: PostRepository = PostRepositoryImpl(apiClient)
    val commentRepository: CommentRepository = CommentRepositoryImpl(apiClient)
    val authRepository: AuthRepository = AuthRepositoryImpl(apiClient)
    val tagRepository: TagRepository = TagRepositoryImpl(apiClient)
    val notificationRepository: NotificationRepository = NotificationRepositoryImpl(apiClient)

    // UseCases
    val loadPostListUseCase = LoadPostListUseCase(postRepository)
    val loadPostListWithPaginationUseCase = LoadPostListWithPaginationUseCase(postRepository)
    val searchPostsUseCase = SearchPostsUseCase(postRepository)
    val loadPostDetailUseCase = LoadPostDetailUseCase(postRepository)
    val loadCommentsUseCase = LoadCommentsUseCase(commentRepository)
    val createCommentUseCase = CreateCommentUseCase(commentRepository)
    val createPostUseCase = CreatePostUseCase(postRepository)
    val adminLoginUseCase = AdminLoginUseCase(authRepository)
    val deleteCommentUseCase = DeleteCommentUseCase(commentRepository)
    val bulkDeleteCommentsUseCase = BulkDeleteCommentsUseCase(commentRepository)
    val updatePostUseCase = UpdatePostUseCase(postRepository)
    val deletePostUseCase = DeletePostUseCase(postRepository)
    val uploadImageUseCase = UploadImageUseCase(apiClient)
    val loadPopularTagsUseCase = LoadPopularTagsUseCase(tagRepository)
    val loadPostTagsUseCase = LoadPostTagsUseCase(tagRepository)
    val createTagUseCase = CreateTagUseCase(tagRepository)

    // Notification UseCases
    val getNotificationSettingsUseCase = GetNotificationSettingsUseCase(notificationRepository)
    val updateNotificationSettingsUseCase = UpdateNotificationSettingsUseCase(notificationRepository)
    val getNotificationsUseCase = GetNotificationsUseCase(notificationRepository)
    val markNotificationAsReadUseCase = MarkNotificationAsReadUseCase(notificationRepository)
    val markAllNotificationsAsReadUseCase = MarkAllNotificationsAsReadUseCase(notificationRepository)
}
